export default __webpack_public_path__ + "static/media/InsideHeart_05.819bd225.png";